import { createFileRoute } from '@tanstack/react-router'
import { MeusDocumentos } from '@/features/meus-documentos'
import { requireAtestadosAccess } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/meus-documentos/')({
  beforeLoad: async () => {
    await requireAtestadosAccess()
  },
  component: MeusDocumentos,
})

